export default __webpack_public_path__ + "static/media/moredetails.3fdf41f6.svg";